module.exports = __webpack_public_path__ + "static/media/team-member5.98f9548b.png";